<template>
  <div class="top-contianer" style="background:white;">
    <!--<img width='100%' src='../../public/img/background.png'>-->
    <template>
      <div class="grey">
        <!-- <img width='100%' src='../../public/img/background3.png'>-->
        <div
          class="main_header"
          style="background-color: #f2f2f2; width: 100%; text-align: center;"
        >
          <!-- <div style="width: 60%; margin:auto;">
            <b-img-lazy src="../../public/img/team/team-all.png" class="w-100"></b-img-lazy>
          </div>-->
          <div>
            <h1
              style="width: 80%; margin: auto;color: #00264a;"
            >Get to know the talented people who power</h1>
            <h1 style="color: #00264a; font-weight: bold;">VORTEX</h1>
            <h5
              class="tips"
            >Meet our energetic, special and hard-working team, feel free to get in touch with us</h5>
          </div>
        </div>
        <div class="grey_strip"></div>
      </div>

      <GearsSep />
      <div>
        <b-card no-body class="overflow-hidden info-card card-ceo">
          <b-row no-gutters>
            <b-col md="3">
              <div class="image-container">
                <b-card-img-lazy
                  src="../../public/img/team/aboklila1.jpg"
                  class="rounded-20 overlay-linkedin"
                ></b-card-img-lazy>
                <div class="middle">
                  <div>
                    <a target="_blank" href="https://www.linkedin.com">
                      <i class="fa fa-linkedin-square" style="font-size:48px;"></i>
                    </a>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col md="6">
              <b-card-body>
                <b-card-title class="fc-p">Abdelrahman Abouklila</b-card-title>
                <h5>CEO</h5>
                <b-card-text class="grey_text">
                  A visionary, energetic leader responsible for VORTEX's strategy and growth.
                  Devoted to providing the best service by realizing the company's full potential.
                  <br />
                  <a
                    target="_blank"
                    class="mailto"
                    href="mailto:abdelrahman.abouklila@vortex-co.com"
                  >&nbsp; &nbsp; abdelrahman.abouklila@vortex-co.com</a>
                </b-card-text>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
      </div>

      <div>
        <b-card no-body class="overflow-hidden info-card card-cto">
          <b-row no-gutters class="justify-content-end">
            <b-col id="cto_pic_up" md="3">
              <b-card-img-lazy
                src="../../public/img/team/maradny1.jpg"
                class="rounded-0 overlay-linkedin"
              ></b-card-img-lazy>
            </b-col>
            <b-col md="6">
              <b-card-body>
                <b-card-title class="fc-p">Abdelrahman Elmaradny</b-card-title>
                <h5>CTO Mechanical</h5>
                <b-card-text class="grey_text">
                  A visionary, energetic leader responsible for VORTEX's strategy and growth.
                  Devoted to providing the best service by realizing the company's full potential.
                  <br />
                  <a
                    target="_blank"
                    class="mailto"
                    href="mailto:abdelrahman.elmaradny@vortex-co.com"
                  >&nbsp; &nbsp; abdelrahman.elmaradny@vortex-co.com</a>
                </b-card-text>
              </b-card-body>
            </b-col>
            <b-col id="cto_pic_down" md="3">
              <div class="image-container">
                <b-card-img-lazy
                  src="../../public/img/team/maradny1.jpg"
                  class="rounded-0 overlay-linkedin"
                ></b-card-img-lazy>
                <div class="middle">
                  <a target="_blank" href>
                    <i class="fa fa-linkedin-square" style="font-size:48px;"></i>
                  </a>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </div>

      <div>
        <b-card no-body class="overflow-hidden info-card card-ceo">
          <b-row no-gutters>
            <b-col md="3">
              <div class="image-container">
                <b-card-img-lazy
                  src="../../public/img/team/youssry.jpg"
                  class="rounded-20 overlay-linkedin"
                ></b-card-img-lazy>
                <div class="middle">
                  <div>
                    <a target="_blank" href="https://www.linkedin.com/in/ibrahim-habib-b8053310b">
                      <i class="fa fa-linkedin-square" style="font-size:48px;"></i>
                    </a>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col md="6">
              <b-card-body>
                <b-card-title class="fc-p">Ibrahim Youssry</b-card-title>
                <h5>CTO Software</h5>
                <b-card-text class="grey_text">
                  A Software technology enthusiast with a speciality of making things work.
                  He's responsible for the continuous development of any Software related projects in VORTEX
                  through bespoke processes.
                  <br />
                  <a
                    target="_blank"
                    class="mailto"
                    href="mailto:ibrahim.habib@vortex-co.com"
                  >&nbsp; &nbsp; ibrahim.habib@vortex-co.com</a>
                </b-card-text>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
      </div>
      <h5 id="breakeer">____________________________________________________________________</h5>
      <br />
      <br />
      <br />
      <b-container width="100%" class="bv-example-row mb-3">
        <b-row :cols="numOfCols" id="team_row">
          <b-col v-for="worker in workers" :key="worker.id">
            <div>
              <b-card
                style="text-align: center; border: none;"
                class="mb-2"
                rounded="circle"
                rounded-circle
              >
                <b-card-body>
                  <div class="image-container">
                    <b-card-img-lazy
                      :src="worker.picture"
                      class="card-img-top overlay-linkedin"
                      img-alt="Image"
                      img-top
                      rounded="circle"
                    ></b-card-img-lazy>
                    <div class="middle">
                      <a target="_blank" :href="worker.linkedin">
                        <i class="fa fa-linkedin-square" style="font-size:48px;"></i>
                      </a>
                    </div>
                  </div>

                  <b-card-title class="mt-3 fc-p fw-n">{{worker.name}}</b-card-title>
                  <b-card-text style="margin-top: -4%;">{{worker.role}}</b-card-text>
                  <b-card-text style="margin-top: -3%; font-weight: bold;">{{worker.position}}</b-card-text>
                </b-card-body>
              </b-card>
            </div>
          </b-col>
        </b-row>
      </b-container>

      <div class="my_carousel">
        <b-carousel
          id="carousel-1"
          :interval="2000"
          controls
          indicators
          background="#ababab"
          img-width="1024"
          img-height="480"
          style="text-shadow: 1px 1px 2px #333;"
        >
          <!-- Text slides with image -->
          <b-carousel-slide img-src="../../public/img/team/alll1.jpg"></b-carousel-slide>
          <b-carousel-slide img-src="../../public/img/team/alll2.jpg"></b-carousel-slide>
        </b-carousel>
        <br />
        <br />
        <br />
      </div>
    </template>
  </div>
</template>

<style lang='scss' scoped>
.grey_text a {
  background: transparent
    url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxwb2x5Z29uIHN0eWxlPSJmaWxsOiNGMkYyRjI7IiBwb2ludHM9IjQ4NC45NzMsMTIyLjgwOCA0NTIuMjg4LDQ1MS4wMTcgNTkuNzEyLDQ1MS4wMTcgMzMuMzc5LDEyOS4xNiAyNTYsMjUzLjgwMiAJIi8+DQoJPHBvbHlnb24gc3R5bGU9ImZpbGw6I0YyRjJGMjsiIHBvaW50cz0iNDczLjg4Niw2MC45ODMgMjU2LDI2NS42NTkgMzguMTE0LDYwLjk4MyAyNTYsNjAuOTgzIAkiLz4NCjwvZz4NCjxwYXRoIHN0eWxlPSJmaWxsOiNGMTQzMzY7IiBkPSJNNTkuNzEyLDE1NS40OTN2Mjk1LjUyNEgyNC4xMzlDMTAuODEyLDQ1MS4wMTcsMCw0NDAuMjA2LDAsNDI2Ljg3OFYxMTEuOTY3bDM5LDEuMDYzTDU5LjcxMiwxNTUuNDkzDQoJeiIvPg0KPHBhdGggc3R5bGU9ImZpbGw6I0QzMkUyQTsiIGQ9Ik01MTIsMTExLjk2N3YzMTQuOTEyYzAsMTMuMzI3LTEwLjgxMiwyNC4xMzktMjQuMTUyLDI0LjEzOWgtMzUuNTZWMTU1LjQ5M2wxOS42OTItNDYuNTI1DQoJTDUxMiwxMTEuOTY3eiIvPg0KPHBhdGggc3R5bGU9ImZpbGw6I0YxNDMzNjsiIGQ9Ik01MTIsODUuMTIydjI2Ljg0NWwtNTkuNzEyLDQzLjUyNkwyNTYsMjk4LjU2MUw1OS43MTIsMTU1LjQ5M0wwLDExMS45NjdWODUuMTIyDQoJYzAtMTMuMzI3LDEwLjgxMi0yNC4xMzksMjQuMTM5LTI0LjEzOWgxMy45NzVMMjU2LDIxOS43OTJMNDczLjg4Niw2MC45ODNoMTMuOTYyQzUwMS4xODgsNjAuOTgzLDUxMiw3MS43OTQsNTEyLDg1LjEyMnoiLz4NCjxwb2x5Z29uIHN0eWxlPSJmaWxsOiNEMzJFMkE7IiBwb2ludHM9IjU5LjcxMiwxNTUuNDkzIDAsMTQ2LjIzNSAwLDExMS45NjcgIi8+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8L3N2Zz4NCg==)
    center left no-repeat;
  padding-left: 18px;
}
.grey_text {
  color: grey !important;
}
.be_full_width {
  width: 100%;
  left: 0;
}
.card-ceo {
  position: relative;
}
.card-cto {
  position: relative;
}
#cto_pic_up {
  visibility: hidden;
  display: none !important;
}
#cto_pic_down {
  visibility: visible;
  display: block;
}
.card-title {
  font-size: 1.5em;
}
.top-contianer {
  width: 100%;
  background-color: #f2f2f2;
}
.slide {
  width: 100%;
}
.my_carousel {
  overflow: hidden;
  width: 80%;
  margin: auto;
  border: none;
}
.card-ceo .card-img {
  border-radius: 40% !important;
  max-width: 240px;
}
.overlay-linkedin {
  opacity: 1;
  transition: 0.3s ease;
  backface-visibility: hidden;
}

.image-container {
  position: relative;
  max-width: 400px;
}

.middle {
  cursor: pointer;
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 80%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.image-container:hover .overlay-linkedin {
  opacity: 0.5;
}

.image-container:hover .middle {
  opacity: 1;
}

.fw-n {
  font-weight: normal !important;
}

.fc-p {
  color: #05264a;
  font-weight: bold;
}

.card-cto .card-img {
  border-radius: 40% !important;
  max-width: 240px;
}

.card-img-top {
  width: 170px;
  position: relative;
  margin: auto;
  border-radius: 50%;
  display: inline-block;
  height: 170px;
}

@media screen and (max-width: 762px) {
  #cto_pic_up {
    visibility: visible;
    display: block !important;
  }
  #cto_pic_down {
    visibility: hidden;
    display: none !important;
  }

  .justi {
    display: inline-block;
    text-align: center;
  }
  #breakeer {
    display: none !important;
  }
}
@media screen and (max-width: 760px) {
  .card-ceo {
    display: inline-block;
    text-align: center;
    width: 100%;
    left: 0%;
  }
  .card-cto {
    display: inline-block;
    text-align: center;
    width: 100%;
    left: 0%;
  }
  #breakeer {
    display: none !important;
  }
}
@media screen and (max-width: 500px) {
  .tips {
    width: 90%;
  }
  .card-ceo {
    text-align: center;
    width: 100%;
    left: 0%;
  }
  .card-cto {
    text-align: center;
    width: 100%;
    left: 0%;
  }
  .containerdiv {
    display: inline-block;
    text-align: center;
  }
}
@media screen and (max-width: 455px) {
  .mailto {
    font-size: 12px;
  }
}
</style>

<script>
import GearsSep from "./../components/GearsSep.vue";
export default {
  components: {
    GearsSep
  },
  created() {
    window.addEventListener("resize", this.resetNumOfCols);
  },
  destroyed() {
    window.removeEventListener("resize", this.resetNumOfCols);
  },
  mounted() {
    var tabs = document.getElementById("right_nav").querySelectorAll("a");
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].style.color = "#00264a";
    }
    this.resetNumOfCols();
    document
      .getElementById("vortexNameImage")
      .setAttribute("src", "img/logos/vortex_name.png");
  },
  methods: {
    resetNumOfCols() {
      this.numOfCols = Math.ceil(window.innerWidth / 600);
      if (this.numOfCols > 3) this.numOfCols = 3;
    }
  },
  data() {
    return {
      numOfCols: 3,
      counter: 0,
      workers: [
        // {
        //   picture: "img/team/hussein.jpg",
        //   name: "Abdelrahman Hussein",
        //   role: "Mechanical Engineer",
        //   position: "Head of R&D"
        // },
        // {
        //   picture: "img/team/youssry.jpg",
        //   name: "Ibrahim Youssry",
        //   role: "Software Team Lead",
        //   position: "",
        //   linkedin: "https://www.linkedin.com/in/ibrahim-habib-b8053310b"
        // },
        {
          picture: "img/team/mahmoud_assem.jpg",
          name: "Mahmoud Assem",
          role: "Electrical Team Lead",
          position: "",
          linkedin: "https://www.linkedin.com/in/mahmoud-eid-a31433147"
        },
        {
          picture: "img/team/amr.jpg",
          name: "Amr Essam",
          role: "Embedded Software Engineer",
          position: "",
          linkedin: "https://www.linkedin.com/in/amr-khamis/"
        },
        {
          picture: "img/team/moudi.jpg",
          name: "Mohamed Tarek",
          role: "Game Software Engineer",
          position: "",
          linkedin: "Https://www.linkedin.com/in/muhammadtarek0"
        },

        {
          picture: "img/team/hesham.jpg",
          name: "Hesham Saeed",
          role: "Mechanical Engineer",
          position: ""
        },
        {
          picture: "img/team/gemmy.jpg",
          name: "Mohamed Gamal",
          role: "Business Development Engineer",
          position: "",
          linkedin: "https://www.linkedin.com/in/mgamaleid"
        },
        {
          picture: "img/team/abdelaziz.jpg",
          name: "Abdelaziz Youssry",
          role: "Mechanical Engineer",
          position: "",
          linkedin: "https://www.linkedin.com/in/abdelaziz-yousry-65b316187"
        },

        {
          picture: "img/team/islam_gamal.jpg",
          name: "Islam Gamal ",
          role: "Software Engineer",
          position: "",
          linkedin: "https://www.linkedin.com/in/islamgamaal"
        },

        {
          picture: "img/team/desouki.jpg",
          name: "Abdelrahman Desouki",
          role: "Mechanical Engineer",
          position: "",
          linkedin: "http://linkedin.com/in/abdelrahman-desouky-160751135"
        },
        {
          picture: "img/team/omar.jpg",
          name: "Omar Mahmoud",
          role: "Mechanical Engineer",
          position: "",
          linkedin: "https://www.linkedin.com/in/omar-mahmoud-719b34148"
        },

        {
          picture: "img/team/waly.jpg",
          name: "Mohamed Waly",
          role: "Electrical Engineer",
          position: "",
          linkedin: "http://linkedin.com/in/mohamed-waly-a8867bb4"
        },
        {
          picture: "img/team/marwan.jpg",
          name: "Marwan Taha",
          role: "Mechanical Engineer",
          position: ""
        },
        {
          picture: "img/team/maradny2.jpg",
          name: "Abdullah Elmaradny",
          role: "Software Engineer",
          position: ""
        },
        {
          picture: "img/team/abdelmohaymen.jpg",
          name: "Abdlmohimen Mohamed",
          role: "Mechanical Design Engineer",
          position: ""
        },
        {
          picture: "img/team/aboklila2.jpg",
          name: "Mohamed Abou-klila",
          role: "Mechanical Engineer",
          position: ""
        },
        {
          picture: "img/team/asmaa.jpg",
          name: "Asmaa Bahaa",
          role: "Mechanical Engineer",
          position: "",
          linkedin:
            "https://www.linkedin.com/in/asmaa-baha-al-din-mohamed-a14397125"
        },
        {
          picture: "img/team/belal.jpg",
          name: "Belal Abou-Elkhair",
          role: "Software Engineer",
          position: "",
          linkedin: "https://www.linkedin.com/in/belal-aboelkher-5303201a2/"
        },
        {
          picture: "img/team/hosny.jpg",
          name: "Omar Hosny",
          role: "Embedded Software Engineer",
          position: ""
        },
        {
          picture: "img/team/mahmoud_saeed.jpg",
          name: "Mahmoud Saeed",
          role: "Mechanical Engineer",
          position: "",
          linkedin:
            "https://www.linkedin.com/in/mahmoud-saeed-elmezayen-053617167/"
        },
        {
          picture: "img/team/medhat.jpg",
          name: "Ahmed Medhat",
          role: "Mechanical Engineer",
          position: "",
          linkedin: "https://www.linkedin.com/in/ahmed-medhat-7159aa1b5"
        },
        {
          picture: "img/team/nabil.jpg",
          name: "Mohamed Nabil",
          role: "Software Engineer",
          position: "",
          linkedin: "http://linkedin.com/in/passionatentj"
        },
        {
          picture: "img/team/ziad.jpg",
          name: "Ziad Abdelkarim",
          role: "Electrical Engineer",
          position: ""
        },
        {
          picture: "img/team/shanawany.jpg",
          name: "Omar Elshanawany",
          role: "Electrical Engineer",
          position: ""
        },
        {
          picture: "img/team/karim.jpg",
          name: "Karim ElSayed",
          role: "Mechanical Engineer",
          position: "",
          linkedin: "https://www.linkedin.com/in/egkarim"
        },
        {
          picture: "img/team/lina.jpg",
          name: "Lina Nassar",
          role: "Mechanical Engineer",
          position: "",
          linkedin: "https://www.linkedin.com/in/lina-nassar-37664517b"
        },
        {
          picture: "img/team/hamdy.jpg",
          name: "Ahmed Hamdy",
          role: "Mechanical Engineer",
          position: ""
        }
      ]
    };
  }
};
</script>
